module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-wildfly-02-m.a940193989cc481ab3362667deabd018.png";